import React from 'react';

import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';

const Text7week = () => {
  const { t } = useTranslation();

  return (
    <div data-bem="Text7week">
      {S.space}
      <div className="bottom-text">
        <span>{t('clientConnect.sectionsDescriptionPart1')}</span> {t('clientConnect.section6DescriptionPart2')}
      </div>
    </div>
  );
};

export default Text7week;
